<template>
</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';

export default {
    name: 'CardUpdatable',
    components: {
        ddoAlert
    },
    props: {
       row: Object,
       level: Object
    },
    data: function () {
        return {
        }
    },
    created() {
    }
}
</script>